import { TFunction } from 'i18next';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  FormOutlined,
  StopOutlined,
  SyncOutlined,
  WarningOutlined,
} from '@ant-design/icons';

import { TableTagMappings } from '@ohpen/enso-ui';
import { ActionStatus, ChangeRequestResponse } from '@pmp/api';

export const getActionStatusTagMappings = (t: TFunction): TableTagMappings => ({
  status: {
    [ActionStatus.DRAFT]: { color: '', icon: <EditOutlined /> },
    [ActionStatus.PENDING_REVIEW]: { color: 'orange', icon: <FormOutlined /> },
    [ActionStatus.PENDING_RESUBMISSION]: { color: 'yellow', icon: <EditOutlined /> },
    [ActionStatus.APPROVED]: { color: 'success', icon: <CheckCircleOutlined /> },
    [ActionStatus.PENDING_PROCESSING]: { color: 'processing', icon: <SyncOutlined spin /> },
    [ActionStatus.PROCESSING]: { color: 'processing', icon: <SyncOutlined spin /> },
    [ActionStatus.APPLIED]: { color: 'success', icon: <CheckCircleOutlined />, solid: true },
    [ActionStatus.PARTIALLY_APPLIED]: {
      color: 'warning',
      icon: <WarningOutlined />,
      solid: true,
      tooltip: { title: t('global.labels.changeRequestErrorTooltip') },
    },
    [ActionStatus.NOT_APPLIED]: {
      color: 'error',
      icon: <CloseCircleOutlined />,
      solid: true,
      tooltip: (record: unknown) => {
        const { processingError } = record as ChangeRequestResponse;
        return { title: processingError || t('global.labels.changeRequestErrorTooltip') };
      },
    },
    [ActionStatus.REJECTED]: { color: 'red', icon: <CloseCircleOutlined /> },
    [ActionStatus.DELETED]: { color: 'red', icon: <CloseCircleOutlined /> },
    [ActionStatus.INVALIDATED]: {
      color: 'default',
      icon: <StopOutlined />,
      tooltip: (record: unknown) => {
        const { invalidationSource } = record as ChangeRequestResponse;
        const source = invalidationSource?.value || invalidationSource?.key;
        return {
          title: source
            ? t('global.labels.changeRequestInvalidatedTooltip', { source })
            : t('global.labels.changeRequestInvalidatedTooltipGeneric'),
        };
      },
    },
  },
});
